import { Card, CircularProgress } from "@mui/material";
import { useRCAHistoryMainStyles, useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { RCAIssueHistoryLogItem } from "./component";
import { StatusEntity } from "entities/RCA/StatusEntity/StatusEntity";
import { PriorityEntity } from "entities/RCA/PriorityEntity/PriorityEntity";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IHistoryLogIssue } from "entities/RCA/IssueEntity/IIssueEntityInterfaces";

export const RCAIssueHistoryLogs = ({ logs, loadingLogs }: { logs: IHistoryLogIssue[]; loadingLogs: boolean }) => {
    const classes = useRCAHistoryMainStyles();
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();

    const { statuses, loading: loadingStatusesOptions } = StatusEntity.GetStatuses();
    const { priorities, loading: loadingPrioritiesOptions } = PriorityEntity.GetPriorities();

    const historyLogs = useMemo(() => {
        if (loadingStatusesOptions || loadingPrioritiesOptions || loadingLogs) {
            return (
                <div className={classes.cardContentLoading}>
                    <CircularProgress color="info" />
                </div>
            );
        }
        return (
            <div className={classes.cardContent}>
                {logs.map((log) => (
                    <RCAIssueHistoryLogItem
                        log={log}
                        key={log.history_id}
                        statuses={statuses}
                        priorities={priorities}
                    />
                ))}
            </div>
        );
    }, [loadingStatusesOptions, loadingPrioritiesOptions, loadingLogs, logs, classes, priorities, statuses]);

    return (
        <Card className={`${mainClasses.contentCard} ${classes.card}`}>
            <div className={mainClasses.contentCardHeader}>
                <div className={mainClasses.contentCardTitle}>{t("rca.history_audit_logs.title")}</div>
            </div>
            {historyLogs}
        </Card>
    );
};
